import axios from 'axios';

axios.interceptors.response.use(
    response => response
    ,error => {
//        console.log(error);
//        console.log(error.response);
        
        if (error && error.response && [401, 419].indexOf(error.response.status) > -1) {
            window.Toast.fire({
                icon: 'error',
                title: 'not logged in'
            });
         // Reload or redirect to login page
            window.location.reload();

            return Promise.reject(error);
        }
        throw error;
    }
);

export default{
    axios
}